"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShouldQueryForGroup = void 0;
exports.getShouldQueryForGroup = (group) => {
    return {
        bool: {
            should: [
                {
                    term: {
                        groupIds: {
                            value: group._id || group.id
                        }
                    }
                },
                {
                    term: {
                        dynamicGroupIds: {
                            value: group._id || group.id
                        }
                    }
                }
            ],
            minimum_should_match: 1
        }
    };
};
//# sourceMappingURL=getShouldQueryForGroup.js.map